import React from 'react'
import SignUpForm from '../../../components/form/signUp'

/*const initialValues = { email: '', password: '' }
const validations = yup.object().shape({
  email: yup
    .string()
    .email('Email no válido')
    .required('Campo requerido'),
  password: yup.string().required('Campo requerido')
})


FormLogin.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleSeePaswordChange: PropTypes.func.isRequired
}
  */

function SignUp() {
	return <SignUpForm />
}

export default SignUp
